import { gql } from '@apollo/client';
import type * as Types from './Types';

export type BaseDepositFragment = {
  _id: string;
  amount: number;
  currency: Types.FiatCurrency;
  status: Types.DepositStatus;
  method: Types.DepositMethod;
  createdAt: string;
  wallet: string;
  user: { _id: string; email: string };
};

export const BaseDepositFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseDeposit on Deposit {
    _id
    amount
    currency
    status
    method
    createdAt
    user {
      _id
      email
    }
    wallet
  }
`;
